import { useCallback, useState } from "react";

export type ThemePreference = "light" | "dark" | "system";

const KEY = "websede.theme";

/** The saved choice; light unless the user picked something else (index.html applies it early). */
export function readTheme(): ThemePreference {
  try {
    const saved = localStorage.getItem(KEY);
    return saved === "dark" || saved === "system" ? saved : "light";
  } catch {
    return "light";
  }
}

export function useTheme(): [ThemePreference, (theme: ThemePreference) => void] {
  const [theme, setState] = useState(readTheme);
  const setTheme = useCallback((next: ThemePreference) => {
    document.documentElement.dataset.theme = next;
    try {
      localStorage.setItem(KEY, next);
    } catch {
      // Private mode or blocked storage: the choice holds for this page only.
    }
    setState(next);
  }, []);
  return [theme, setTheme];
}
